/* ============================================================
   Craft Com — galeries visibles direct + avis en carrousel
   Chargé après app.js (réutilise openGallery / openLight).
   ============================================================ */
(function(){
  const G = window.CRAFTCOM_GALLERY = window.CRAFTCOM_GALLERY || {};

  /* ---- Vidéos hébergées sur Shopify Files -> items de galerie ---- */
  const VCDN='https://cdn.shopify.com/videos/c/vp/';
  const PCDN='https://cdn.shopify.com/s/files/1/1002/1503/0144/files/preview_images/';
  const toItem = ([h,rate,ext]) => ({
    src:   `${VCDN}${h}/${h}.HD-720p-${rate}Mbps-${ext}.mp4`,
    small: `${VCDN}${h}/${h}.SD-480p-${rate==='3.0'?'1.2':'1.5'}Mbps-${ext}.mp4`,
    poster:`${PCDN}${h}.thumbnail.0000000000.jpg?width=540`
  });
  const V = window.CRAFTCOM_VIDEOS || {};
  Object.keys(V).forEach(k => { G[k] = V[k].map(toItem); });
  /* les vidéos pub sont rangées avec les vidéos IA */
  G.ia = (G.ia || []).concat(G.video || []);

  /* ---- Catégories de la vitrine ---- */
  const SC_CATS = [
    {id:'flyers',  name:'Flyers'},
    {id:'ia',      name:'Vidéos IA'},
    {id:'motion',  name:'Motion design'},
    {id:'menus',   name:'Menus'},
    {id:'social',  name:'Réseaux sociaux'},
    {id:'shopify', name:'Sites web'},
  ].filter(c => (G[c.id]||[]).length);

  const kind = e => {
    if (e && typeof e === 'object') return e.url ? 'link' : 'video';
    return /\.mp4(\?|$)/i.test(String(e)) ? 'video' : 'image';
  };

  /* Lightbox hors de l'overlay pour pouvoir l'ouvrir seule */
  function lightFor(cat, i){
    if (typeof ensureGalleryDOM !== 'function') return;
    ensureGalleryDOM();
    const light = document.getElementById('galLight');
    if (light && light.parentElement.id === 'galOverlay') document.body.appendChild(light);
    _galImgs = G[cat.id] || [];
    _galItems = _galImgs.map(galItem);
    openLight(i);
  }

  function buildShowcase(){
    const tabs = document.getElementById('scTabs'), track = document.getElementById('scTrack');
    if (!tabs || !track || !SC_CATS.length) return;
    const prev = document.getElementById('scPrev'), next = document.getElementById('scNext');
    let current = SC_CATS[0];

    const vio = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target;
      if (e.isIntersecting) { if (!v.src) v.src = v.dataset.src; v.play().catch(()=>{}); }
      else v.pause();
    }), {root: track, threshold: .55});

    function render(cat){
      current = cat;
      track.querySelectorAll('video').forEach(v => { vio.unobserve(v); v.pause(); });
      track.innerHTML = '';
      (G[cat.id]||[]).forEach((e, i) => {
        const k = kind(e);
        let el;
        if (k === 'link') {
          el = document.createElement('a');
          el.href = e.url; el.target = '_blank'; el.rel = 'noopener';
          el.className = 'sc-item is-link';
          el.innerHTML = `<img loading="lazy" src="${e.logo||e.poster||''}" alt="${cat.name} ${i+1}"><span class="sc-badge">Voir le site ↗</span>`;
        } else {
          el = document.createElement('button');
          el.type = 'button';
          el.className = 'sc-item' + (k === 'video' ? ' is-video' : '');
          if (k === 'video') {
            const src = typeof e === 'object' ? (e.small || e.src) : e;
            const poster = typeof e === 'object' ? (e.poster || '') : '';
            el.innerHTML = `<video muted loop playsinline preload="none" data-src="${src}"${poster?` poster="${poster}"`:''}></video><span class="sc-play" aria-hidden="true"></span>`;
            const v = el.querySelector('video');
            v.addEventListener('loadedmetadata', () => { if (v.videoWidth) el.style.aspectRatio = v.videoWidth + '/' + v.videoHeight; });
            vio.observe(v);
          } else {
            el.innerHTML = `<img loading="${i < 5 ? 'eager' : 'lazy'}" src="${e}" alt="${cat.name} ${i+1}">`;
          }
          el.addEventListener('click', () => { if (!track._moved) lightFor(cat, i); });
        }
        track.appendChild(el);
      });
      track.scrollLeft = 0;
      tabs.querySelectorAll('.sc-tab').forEach(b => b.setAttribute('aria-selected', b.dataset.id === cat.id));
      arrows();
    }

    SC_CATS.forEach(cat => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'sc-tab'; b.dataset.id = cat.id; b.setAttribute('role','tab');
      b.innerHTML = `${cat.name}<span>${(G[cat.id]||[]).length}</span>`;
      b.addEventListener('click', () => { render(cat); b.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'}); });
      tabs.appendChild(b);
    });

    /* flèches + glisser à la souris */
    const step = d => {
      const it = track.querySelector('.sc-item');
      track.scrollBy({left: d * (it ? it.getBoundingClientRect().width + 16 : 300), behavior:'smooth'});
    };
    function arrows(){
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('hidden', track.scrollLeft <= 2);
      next.classList.toggle('hidden', track.scrollLeft >= max || max <= 0);
    }
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', arrows, {passive:true});
    addEventListener('resize', arrows);

    let down = false, sx = 0, sl = 0;
    track._moved = false;
    track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; track._moved = false; sx = e.clientX; sl = track.scrollLeft; });
    track.addEventListener('pointermove', e => { if (!down) return; if (Math.abs(e.clientX - sx) > 6) { track._moved = true; track.classList.add('drag'); } track.scrollLeft = sl - (e.clientX - sx); });
    addEventListener('pointerup', () => { down = false; setTimeout(() => { track.classList.remove('drag'); track._moved = false; }, 60); });

    /* défilement automatique doux, en pause dès qu'on touche */
    let pausedUntil = 0, visible = false;
    const pause = () => { pausedUntil = Date.now() + 7000; };
    ['pointerdown','wheel','touchstart','mouseenter'].forEach(ev => track.addEventListener(ev, pause, {passive:true}));
    track.addEventListener('mouseleave', () => { pausedUntil = Date.now() + 1500; });
    new IntersectionObserver(es => { visible = es[0].isIntersecting; }, {threshold:.4}).observe(track);
    setInterval(() => {
      if (!visible || document.hidden || Date.now() < pausedUntil) return;
      if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= max) track.scrollTo({left:0, behavior:'smooth'}); else step(1);
    }, 3200);

    const all = document.getElementById('scAll');
    if (all) all.addEventListener('click', () => { if (typeof openGallery === 'function') openGallery(current); });

    render(current);
  }

  /* ---- Avis : carrousel, texte coupé, 12 max ---- */
  function tidyReviews(){
    const g = document.getElementById('revGrid');
    if (!g) return;
    const MAX = 12;
    const fix = () => {
      [...g.children].forEach((c, i) => {
        if (i >= MAX) { c.remove(); return; }
        c.classList.add('in');
        if (c.dataset.tidy) return;
        c.dataset.tidy = '1';
        const p = c.querySelector('p');
        if (!p) return;
        requestAnimationFrame(() => {
          if (p.scrollHeight - p.clientHeight < 4) return;
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'rev-more'; b.textContent = 'Lire plus';
          b.addEventListener('click', () => { const o = c.classList.toggle('open'); b.textContent = o ? 'Réduire' : 'Lire plus'; });
          p.after(b);
        });
      });
      revArrows();
    };
    new MutationObserver(fix).observe(g, {childList:true});
    fix();

    const prev = document.getElementById('revPrev'), next = document.getElementById('revNext');
    const step = d => { const c = g.querySelector('.rev'); g.scrollBy({left: d * (c ? c.getBoundingClientRect().width + 18 : 320), behavior:'smooth'}); };
    function revArrows(){
      if (!prev || !next) return;
      const max = g.scrollWidth - g.clientWidth - 2;
      prev.classList.toggle('hidden', g.scrollLeft <= 2);
      next.classList.toggle('hidden', g.scrollLeft >= max || max <= 0);
    }
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    g.addEventListener('scroll', revArrows, {passive:true});
    addEventListener('resize', revArrows);
  }

  buildShowcase();
  tidyReviews();
})();
